import { render } from "./BlockedUserComponent.vue?vue&type=template&id=2e9a3505"
import script from "./BlockedUserComponent.vue?vue&type=script&lang=js"
export * from "./BlockedUserComponent.vue?vue&type=script&lang=js"

import "./BlockedUserComponent.vue?vue&type=style&index=0&id=2e9a3505&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__